import { configureStore } from '@reduxjs/toolkit';
import accountReducer from './accountSlice';
import authReducer from './authSlice';
import chatReducer from './chatSlice';
import domainReducer from './domainSlice';
import facebookReducer from './facebookSlice';
import googleSlice from './googleSlice';
import klaviyoSlice from './klaviyoSlice';
import subscriptionSlice from './subscriptionSlice';
import tiktokSlice from './tiktokSlice';
import whatsappReducer from './whatsappSlice';

export default configureStore({
  reducer: {
    auth: authReducer,
    chat: chatReducer,
    domain: domainReducer,
    account: accountReducer,
    facebook: facebookReducer,
    whatsapp: whatsappReducer,
    google: googleSlice,
    subscription: subscriptionSlice,
    tiktok: tiktokSlice,
    klaviyo: klaviyoSlice,
  },
});
